import { GfsAssessmentAreasPage } from "@/services/backend/gfs/assessment/components/assessment-areas-page";

export default function GfsAssessmentAreasRoute() {
  return <GfsAssessmentAreasPage />;
}
